import { Switch, Tooltip } from "antd";
import { SvgIcon } from "assets/icons";
import CustomModal from "components/CustomModal";
import LockComponent from "components/LockComponent";

function LoyaltyTableActions({
  isActive,
  switchLoading,
  onToggle,
  confirmOnMessage,
  confirmOffMessage,
  showClone = false,
  onClone,
  cloneTooltip,
  showEdit = false,
  onEdit,
  editTooltip,
}) {
  return (
    <div className="loyalty-action-cell">
      <CustomModal
        message={<p className="user-name">{isActive ? confirmOffMessage : confirmOnMessage}</p>}
        centered
        closable
        footer={false}
        onOke={onToggle}
        customIcon={<LockComponent locked={isActive} />}
        buttonLoading={switchLoading}
        customComponent={<Switch checkedChildren="ON" unCheckedChildren="OFF" checked={isActive} />}
      />
      {showClone && (
        <Tooltip title={cloneTooltip}>
          <SvgIcon.CloneProduct className="loyalty-action-icon" onClick={onClone} />
        </Tooltip>
      )}
      {showEdit ? (
        <Tooltip title={editTooltip}>
          <SvgIcon.EditIcon className="loyalty-action-icon loyalty-action-icon--edit" onClick={onEdit} />
        </Tooltip>
      ) : (
        <span className="loyalty-action-icon-placeholder loyalty-action-icon-placeholder--edit" />
      )}
    </div>
  );
}

export default LoyaltyTableActions;
